export const throttle = <T extends (...args: any[]) => any>(
  func: T,
  ms: number
): ((...args: Parameters<T>) => void) => {
  let isThrottled = false;
  let savedArgs: Parameters<T> | null = null;
  let savedThis: any;

  const wrapper = function (this: any, ...args: Parameters<T>) {
    if (isThrottled) {
      savedArgs = args;
      savedThis = this;
      return;
    }

    isThrottled = true;
    func.apply(this, args);

    setTimeout(() => {
      isThrottled = false;

      if (savedArgs) {
        wrapper.apply(savedThis, savedArgs);
        savedArgs = null;
        savedThis = null;
      }
    }, ms);
  };

  return wrapper;
};
